/**
 *
 * @module accountGrant
 *
 */

import Check from 'check-types';
import Token from './../token/entry';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString,
    object
} = Check.assert;

/**
 *
 * @class AccountGrant
 * @extends {SDK.Services.Token.Grant}
 * @desc A special type of grant used for exchanging account information for a token.
 * @note services returns grant_type NOT grantType and is renamed when destructured
 *
 */
export default class AccountGrant extends Token.Grant {

    /**
     *
     * @param {Object} options
     * @param {String} options.assertion
     * @param {Object} options.grant_type
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'AccountGrant(options)',
            get options() {
                return `${this.ctor} options should be an Object`;
            },
            get assertion() {
                return `${this.ctor} options.assertion should be a String with length`;
            },
            get grantType() {
                return `${this.ctor} options.grantType should be a String with length`;
            }
        };

        object(options, errorMessage.options, InvalidArgumentException);

        const { assertion, grant_type: grantType } = options;

        nonEmptyString(assertion, errorMessage.assertion, InvalidArgumentException);

        if (Check.assigned(grantType)) {
            nonEmptyString(grantType, errorMessage.grantType, InvalidArgumentException);
        }

        super(grantType, assertion);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.subjectTokenTypeKey = 'account';

    }

}



// WEBPACK FOOTER //
// ./src/services/account/accountGrant.js